











import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { GrantsRemainingCurrent, TunesSummaryResource } from '@/api/tunessummary';

interface TunesGrantsRemainingItem {
  totalOutstandingGrants: number;
  totalOutstandingAmountRemaining: string;
}

@Component({
  computed: mapState(['fiId']),
})
export default class TunesGrantsRemainingTable extends Vue {
  fiId!: string;

  loading: boolean = true;

  headers: DataTableHeader[] = [
    { text: 'Total Outstanding Grants', value: 'totalOutstandingGrants', width: '200px' },
    { text: 'Total Outstanding Grants Amount Remaining', value: 'totalOutstandingAmountRemaining' },
  ];

  items: TunesGrantsRemainingItem[] = [];

  @Inject('TunesSummaryResource')
  tunesSummaryResource!: TunesSummaryResource;

  mounted() {
    this.loadData();
  }

  @Watch('fiId')
  async loadData() {
    this.loading = true;
    this.items = [];

    await this.tunesSummaryResource.getGrantsRemainingCurrent(this.fiId)
      .then((result: GrantsRemainingCurrent) => {
        this.items = [{
          totalOutstandingGrants: result.totalOutstandingGrants,
          totalOutstandingAmountRemaining: TunesGrantsRemainingTable.formatDollarAmount(result.totalOutstandingAmountRemaining),
        }];
      }).catch((error: any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.loading = false;
      });
  }

  static formatDollarAmount(value: any) {
    return `${value !== null ? `$${Number(value).toFixed(2)}` : ''}`;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
